import { __spreadArray } from 'tslib';

/* Type size */
var UitkTypeSizeMap = [
    [100, 'uitk-type-100'],
    [200, 'uitk-type-200'],
    [300, 'uitk-type-300'],
    [400, 'uitk-type-400'],
    [500, 'uitk-type-500'],
    [600, 'uitk-type-600'],
    [700, 'uitk-type-700'],
    [800, 'uitk-type-800'],
    [900, 'uitk-type-900']
];
var UitkTypeSizes = new Map(UitkTypeSizeMap);
/* Type weight */
/** ******************* */
var UitkTypeWeightMap = [
    ['regular', 'uitk-type-regular'],
    ['medium', 'uitk-type-medium'],
    ['bold', 'uitk-type-bold']
];
var UitkTypeWeights = new Map(UitkTypeWeightMap);
/* Type alignment */
/** ******************* */
var UitkTypeAlignmentMap = [
    ['left', 'uitk-type-start'],
    ['right', 'uitk-type-end'],
    ['center', 'uitk-type-center']
];
var UitkTypeAlignments = new Map(UitkTypeAlignmentMap);
/* Type overflow */
/** ******************* */
var UitkTypeOverflowMap = [
    ['wrap', 'overflow-wrap'],
    ['truncate', 'truncate'],
    ['truncate-2-lines', 'truncate-lines-2'],
    ['truncate-3-lines', 'truncate-lines-3'],
    ['truncate-4-lines', 'truncate-lines-4']
];
var UitkTypeOverflows = new Map(UitkTypeOverflowMap);
/* Type hyphens */
/** ******************* */
var UitkTypeHyphensMap = [
    ['none', 'hyphens-none'],
    ['manual', 'hyphens-manual'],
    ['auto', 'hyphens-auto']
];
var UitkTypeHyphens = new Map(UitkTypeHyphensMap);
/* Heading size */
/** ******************* */
var UitkHeadingSizeMap = [
    [1, 'uitk-heading-1'],
    [2, 'uitk-heading-2'],
    [3, 'uitk-heading-3'],
    [4, 'uitk-heading-4'],
    [5, 'uitk-heading-5'],
    [6, 'uitk-heading-6'],
    [7, 'uitk-heading-7'],
    [8, 'uitk-heading-8']
];
var UitkHeadingSizes = new Map(UitkHeadingSizeMap);
/* Paragraph size */
/** ******************* */
var UitkParagraphSizeMap = [
    [1, 'uitk-paragraph-1'],
    [2, 'uitk-paragraph-2'],
    [3, 'uitk-paragraph-3']
];
var UitkParagraphSizes = new Map(UitkParagraphSizeMap);
/* Type margin */
/** ******************* */
var UitkTypeMarginMap = [
    ['half', 'uitk-text-spacing-half'],
    ['one', 'uitk-text-spacing-one'],
    ['two', 'uitk-text-spacing-two'],
    ['three', 'uitk-text-spacing-three'],
    ['four', 'uitk-text-spacing-four'],
    ['six', 'uitk-text-spacing-six']
];
var UitkTypeMargins = new Map(UitkTypeMarginMap);
/* Heading tag */
/** ******************* */
var UitkHeadingTagMap = [
    ['h1', 'h1'],
    ['h2', 'h2'],
    ['h3', 'h3'],
    ['h4', 'h4'],
    ['h5', 'h5'],
    ['h6', 'h6']
];
var UitkHeadingTags = new Map(UitkHeadingTagMap);
var UitkSubHeadingTagMap = __spreadArray(__spreadArray([], UitkHeadingTagMap, true), [['p', 'p']], false);
var UitkSubHeadingTags = new Map(UitkSubHeadingTagMap);
/* Type theme */
/** ******************* */
var UitkTextThemeMap = [
    ['positive', 'uitk-text-positive-theme'],
    ['negative', 'uitk-text-negative-theme'],
    ['emphasis', 'uitk-text-emphasis-theme'],
    ['default', 'uitk-text-default-theme'],
    ['loyalty', 'uitk-text-loyalty-theme'],
    ['inverse', 'uitk-text-inverse-theme']
];
var UitkTextThemes = new Map(UitkTextThemeMap);
/* Type white space */
/** ******************* */
var UitkTypeWhiteSpaceMap = [
    ['normal', 'uitk-text-white-space-normal'],
    ['nowrap', 'uitk-text-white-space-nowrap'],
    ['pre', 'uitk-text-white-space-pre'],
    ['pre-wrap', 'uitk-text-white-space-pre-wrap'],
    ['pre-line', 'uitk-text-white-space-pre-line'],
    ['break-spaces', 'uitk-text-white-space-break-spaces']
];
var UitkTypeWhiteSpaces = new Map(UitkTypeWhiteSpaceMap);

export { UitkHeadingSizes, UitkHeadingTags, UitkParagraphSizes, UitkSubHeadingTags, UitkTextThemes, UitkTypeAlignments, UitkTypeHyphens, UitkTypeMargins, UitkTypeOverflows, UitkTypeSizes, UitkTypeWeights, UitkTypeWhiteSpaces };
